/* ch2-password.js — countdown on the holding page. Nothing else on this page
   needs script: the password dialog is Dawn's details-modal.js. */
(function () {
  var el = document.querySelector('[data-ch2-countdown]');
  if (!el) return;

  var target = new Date(el.getAttribute('data-ch2-countdown')).getTime();
  // An unparseable date gives NaN, which would render "NaN" in every cell.
  // Leave the list hidden rather than show that.
  if (isNaN(target)) return;

  var timer = null;
  var units = {};
  el.querySelectorAll('[data-unit]').forEach(function (node) {
    units[node.getAttribute('data-unit')] = node;
  });

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var left = target - Date.now();
    if (left <= 0) {
      el.hidden = true;
      if (timer) clearInterval(timer);
      return;
    }
    var s = Math.floor(left / 1000);
    units.days.textContent = pad(Math.floor(s / 86400));
    units.hours.textContent = pad(Math.floor((s % 86400) / 3600));
    units.minutes.textContent = pad(Math.floor((s % 3600) / 60));
    units.seconds.textContent = pad(s % 60);
  }

  // Fill it before revealing, so the placeholder dashes never flash on screen.
  // tick() sets hidden itself when the date has already passed — don't undo that.
  tick();
  if (target > Date.now()) {
    el.hidden = false;
    timer = setInterval(tick, 1000);
  }
})();
